import { render } from "./InvoiceList.vue?vue&type=template&id=0b62e0aa"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__